"use client";

import { useMemo } from "react";

import type { DiscographyQueryType } from "@/types/discography";

import { parseDiscographyTypeParam } from "./discography-query-type";

/**
 * Resolves discography RPC `type` from the URL `?type=` param, aligned with
 * the route loader's SSR prefetch.
 *
 * 1. URL `type` when valid.
 * 2. On SSR (`window` missing): `serverSnapshot` matches what the route loader
 *    prefetched.
 * 3. Otherwise `auto` (no `type` param).
 */
export function useDiscographyQueryType(
  typeParam: string | null | undefined,
  serverSnapshot: DiscographyQueryType,
): DiscographyQueryType {
  return useMemo(() => {
    const fromParam = parseDiscographyTypeParam(typeParam);
    if (fromParam != null) return fromParam;

    if (typeof window === "undefined") {
      return serverSnapshot;
    }

    return "auto";
  }, [typeParam, serverSnapshot]);
}
